import { render, staticRenderFns } from "./Interface.vue?vue&type=template&id=6641c1ce"
import script from "./Interface.vue?vue&type=script&lang=js"
export * from "./Interface.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports